import { DomainSecretType } from '@pushly/models/lib/enums/domain-secret-type'

/**
 * Human-readable labels for all secret types. Includes system-managed types
 * for exhaustiveness (used in table display if one ever appears in a response).
 */
export const secretTypeLabels: Record<DomainSecretType, string> = {
    [DomainSecretType.TOKEN]: 'Token',
    [DomainSecretType.JSON]: 'JSON',
    [DomainSecretType.USERPASS]: 'Username and password',
    [DomainSecretType.WEBHOOK_SIGNING]: 'Webhook Signing',
}

/**
 * Secret types that users can create and manage through the secrets UI.
 *
 * System-managed types (e.g. WEBHOOK_SIGNING) are excluded — they are created
 * and rotated through dedicated endpoints (the webhook signing section) and
 * filtered from list responses server-side via the SYSTEM_MANAGED flag. This
 * constant exists so the type selector doesn't offer types that would be
 * confusing or non-functional in the general secrets drawer.
 */
export const USER_SELECTABLE_SECRET_TYPES: DomainSecretType[] = [
    DomainSecretType.TOKEN,
    DomainSecretType.JSON,
    DomainSecretType.USERPASS,
]
